import { IResponseError } from 'APIPackage/MainModule/interfaces/IResponseError';

export class ResponseError extends Error {
  timestamp?: string;

  status?: number;

  error?: string;

  path?: string;

  text: string;

  clientErrorCode?: string;

  erpId?: string;

  knoOrganizationName?: string;

  constructor(responseError: IResponseError) {
    super(responseError.message);
    this.name = 'ResponseError';
    this.status = responseError.status;
    this.error = responseError.error;
    this.erpId = responseError.erpId;
    this.knoOrganizationName = responseError.knoOrganizationName;
    this.text = responseError.text;
    this.clientErrorCode = responseError.clientErrorCode;
    this.timestamp = responseError.timestamp;
  }
}
